import {Persistence, ReduxConfiguration} from './types';

const _configuration: ReduxConfiguration[] = [];
const _registrationAllowed = {value: true};

/**
 * Returns an object with all reducers identified with its key for
 * use when creating the combined reducer.
 */
export const getRegisteredExportedReducers = () => {
  _registrationAllowed.value = false;
  return _configuration.reduce(
    (acc, cur) => ({...acc, [cur.key as string]: cur.reducer}),
    {},
  );
};

/**
 * Returns a list of keys for reducers that should be persisted.
 */
export const getRegisteredPersistentReducerKeys = () => {
  _registrationAllowed.value = false;
  return _configuration
    .filter(conf => conf.percistence === 'persistent')
    .map(conf => conf.key);
};

/**
 * Returns an array of the middlewares available
 */
export const getRegisteredReduxMiddleware = () => {
  _registrationAllowed.value = false;
  return _configuration.map(conf => conf.middleware);
};

/**
 * Registers a redux configuration so that it is reachable
 * from within configureStore.
 * @param reduxConfiguration
 */
export const registerWithStore = (
  reduxConfiguration: ReduxConfiguration,
  percistence: Persistence = 'transient',
) => {
  if (!_registrationAllowed.value) {
    throw Error(
      'Registering redux containers after redux initialization is not allowed. ' +
        "Make sure you're not calling registerWithStore in a function or lazy import somewhere to avoid this.",
    );
  }
  _configuration.push({...reduxConfiguration, percistence});
};
